import {
  BookOpen,
  Database,
  FileSpreadsheet,
  Gavel,
  Laptop,
  Lock,
  Mail,
  Presentation,
  Rocket,
  Scale,
  Settings,
  ShieldCheck,
  Users,
  type LucideIcon,
} from "lucide-react";

interface CourseTheme {
  Icon: LucideIcon;
  gradient: string;
}

const rules: Array<{ keywords: string[]; Icon: LucideIcon; gradient: string }> = [
  { keywords: ["phishing", "rekayasa sosial"], Icon: Mail, gradient: "from-amber-500 to-orange-600" },
  { keywords: ["data pribadi", "pdp"], Icon: Lock, gradient: "from-indigo-500 to-indigo-700" },
  { keywords: ["kerja remote", "wfh", " ai "], Icon: Laptop, gradient: "from-sky-500 to-cyan-600" },
  { keywords: ["kesadaran siber", "keamanan informasi"], Icon: ShieldCheck, gradient: "from-teal-500 to-emerald-700" },
  { keywords: ["gratifikasi", "korupsi"], Icon: Gavel, gradient: "from-rose-500 to-red-700" },
  { keywords: ["etika bisnis", "kode etik"], Icon: Scale, gradient: "from-slate-500 to-slate-700" },
  { keywords: ["excel"], Icon: FileSpreadsheet, gradient: "from-green-600 to-emerald-700" },
  { keywords: ["sql", "database"], Icon: Database, gradient: "from-blue-500 to-indigo-600" },
  { keywords: ["kepemimpinan", "manajemen tim"], Icon: Users, gradient: "from-purple-500 to-violet-700" },
  { keywords: ["public speaking", "presentasi"], Icon: Presentation, gradient: "from-pink-500 to-rose-600" },
  { keywords: ["orientasi", "onboarding"], Icon: Rocket, gradient: "from-cyan-500 to-teal-600" },
  { keywords: ["sistem", "tools internal", "panduan"], Icon: Settings, gradient: "from-slate-600 to-slate-800" },
];

/** Picks an icon + gradient for a course cover based on keywords in its
 * title, so the catalog reads as visually varied instead of one repeated
 * blue tile. Falls back to a generic book icon on the default brand color. */
export function getCourseTheme(title: string): CourseTheme {
  const t = ` ${title.toLowerCase()} `;
  for (const rule of rules) {
    if (rule.keywords.some((k) => t.includes(k))) {
      return { Icon: rule.Icon, gradient: rule.gradient };
    }
  }
  return { Icon: BookOpen, gradient: "from-brand-500 to-brand-700" };
}
